import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useAccount } from "../account"
import { useFollows } from "./useFollows"
import { useFollowedUsers } from "src/contexts/FollowedUsersContext"

export function useFollow(followingAccountId?: Follow["following_account_id"]) {
  const { data: follows } = useFollows()
  const { currentUserId } = useFollowedUsers()

  const { data: account } = useAccount()
  const accountId = account?.id

  const currentAccountId = followingAccountId ?? currentUserId

  return useMemo(
    () => follows?.find(
      (cachedFollow) => cachedFollow.account_id === accountId &&
          cachedFollow.following_account_id === currentAccountId &&
          cachedFollow.deleted_at === null,
    ),
    [
      follows,
      accountId,
      currentAccountId,
    ],
  )
}
